
import { Options, Vue } from "vue-class-component";
import { Watch } from "vue-property-decorator";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";

@Options({
  props: {
    trackNumber: Number,
    audioContext: AudioContext,
    audioBuffer: AudioBuffer,
    playing: Boolean,
    stop: Number,
    color: String
  },
  components: {
    VueSlider
  }
})
export default class AudioTrack extends Vue {
  audioContext!: AudioContext;
  audioBuffer!: AudioBuffer;
  playing!: boolean;
  trackNumber!: number;
  color!: string;

  collapsed = true;
  enabled = true;

  bufferSourceNode!: AudioBufferSourceNode;
  panNode!: StereoPannerNode;
  gainNode!: GainNode;

  previewPlaying = false;
  locator = [0, 1];
  endLocation!: number;
  loop = true;
  predelay = 0;
  playbackSpeed = 1;
  panLocation = 0;
  gain = 1;

  get playbackStart() {
    return this.audioBuffer.duration * this.locator[0];
  }

  get playbackEnd() {
    return this.audioBuffer.duration * this.locator[1];
  }

  get duration() {
    return this.playbackEnd - this.playbackStart;
  }

  get colorStyle() {
    return {
      backgroundColor: this.color
      //opacity: "30%"
    };
  }

  @Watch("playing")
  onPlayStateChange() {
    if (!this.playing) {
      if (this.bufferSourceNode) this.bufferSourceNode.stop(0);
      this.previewPlaying = false;
    } else if (this.playing && this.enabled) {
      this.trigger();
    }
  }

  @Watch("stop")
  onStopChange() {
    if (this.bufferSourceNode) this.bufferSourceNode.stop(0);
    this.previewPlaying = false;
  }

  onPowerOff() {
    console.log("HERE");
    this.enabled = !this.enabled;
    this.onStopChange();
  }

  initializeDevice() {
    this.bufferSourceNode = this.audioContext.createBufferSource();
    this.bufferSourceNode.buffer = this.audioBuffer;

    this.setLoopLocation();
    this.setPlaybackSpeed();

    this.panNode = this.audioContext.createStereoPanner();
    this.setPanLocation();

    this.gainNode = this.audioContext.createGain();
    this.setGain();

    this.bufferSourceNode.connect(this.panNode);
    this.panNode.connect(this.gainNode);
    this.gainNode.connect(this.audioContext.destination);

    this.bufferSourceNode.start(
      this.audioContext.currentTime + this.predelay,
      this.playbackStart
    );
  }

  trigger() {
    if (this.bufferSourceNode) this.bufferSourceNode.stop(0);
    this.initializeDevice();
    this.previewPlaying = true;
  }

  @Watch("playbackSpeed")
  setPlaybackSpeed() {
    if (this.bufferSourceNode)
      this.bufferSourceNode.playbackRate.value = this.playbackSpeed;
  }

  @Watch("panLocation")
  setPanLocation() {
    if (this.panNode) this.panNode.pan.setValueAtTime(this.panLocation, 0);
  }

  @Watch("gain")
  setGain() {
    if (this.gainNode) this.gainNode.gain.setValueAtTime(this.gain, 0);
  }

  @Watch("locator")
  setLoopLocation() {
    if (this.bufferSourceNode) {
      this.bufferSourceNode.loopStart = this.playbackStart;
      this.bufferSourceNode.loopEnd = this.playbackEnd;
      this.bufferSourceNode.loop = this.loop;
    }
  }
}
